import { BambuserLiveShoppingError } from '../errors/BambuserLiveShoppingError';
import { PLAYER_EVENTS } from '../constants';

/**
 * Exposes functionality from the embed instance
 * in a compatible format for the new public api
 */
export class BambuserLiveShoppingPlayerAPIEmbedInstanceAdapter {
  /**
   * @param {BambuserLiveShopping} embedInstance
   */
  constructor(embedInstance) {
    if (!embedInstance) {
      throw new BambuserLiveShoppingError(
        `Cannot create a BambuserLiveShoppingPlayerAPIEmbedInstanceAdapter
        without an instance of embed.js (BambuserLiveShopping)`,
      );
    }
    this._embedInstance = embedInstance;

    // expose some methods directly
    this.destroy = () => this._embedInstance.destroy();
    this.minimize = (url) => this._embedInstance.minimize(url);
    this.unminimize = () => this._embedInstance.unminimize();
    this.showCheckout = (checkoutUrl) => this._embedInstance.showCheckout(checkoutUrl);
    this.updatePlayerCart = (cartData) => this._embedInstance.updatePlayerCart(cartData);
    this.updateProducts = (products) => this._embedInstance.updateProducts(products);
    this.hideUI = (uiSections) => this._embedInstance.hideUI(uiSections);
    this.showUI = () => this._embedInstance.showUI();
    this.currentPlayerController = () => this._embedInstance.currentPlayerController();
    this.playerControllers = () => this._embedInstance.playerControllers();
    this.externalPlayerControllerEvent = (data) => this._embedInstance.externalPlayerControllerEvent(data);
    this.play = () => this._embedInstance.play();
    this.pause = () => this._embedInstance.pause();
    this.showProductList = () => this._embedInstance.showProductList();
    this.hideProductList = () => this._embedInstance.hideProductList();
    this.getHighlightedProductsList = () => this._embedInstance.playerApiCall(PLAYER_EVENTS.PRODUCT_HIGHLIGHT_LIST, null, true);
    this.seekToPercent = (seekToPercentage) => this._embedInstance.seekToPercent(seekToPercentage);
    this.mute = () => this._embedInstance.mute();
    this.unmute = () => this._embedInstance.unmute();
    this.showCaptions = () => this._embedInstance.showCaptions();
    this.hideCaptions = () => this._embedInstance.hideCaptions();
    this.enableHighContrast = () => this._embedInstance.enableHighContrast();
    this.disableHighContrast = () => this._embedInstance.disableHighContrast();
    this.selectCaptionTrack = (languageCode) => this._embedInstance.selectCaptionTrack(languageCode);
    this.getAvailableCaptions = () => this._embedInstance.getAvailableCaptions();
    this.setTrackingTags = (tags) => this._embedInstance.setTrackingTags(tags);
    this.setRootFontSize = (data) => this._embedInstance.playerApiCall(PLAYER_EVENTS.SET_ROOT_FONT_SIZE, data, false);
    this.patchTheme = (themeOverrides) => this._embedInstance.patchTheme(themeOverrides);
    this.requestPictureInPicture = () => this._embedInstance.playerApiCall(PLAYER_EVENTS.REQUEST_PICTURE_IN_PICTURE, null, true);
    this.exitPictureInPicture = () => this._embedInstance.playerApiCall(PLAYER_EVENTS.EXIT_PICTURE_IN_PICTURE, null, true);
    this.updateSafeAreaInsets = (insets) => this._embedInstance.playerApiCall(PLAYER_EVENTS.UPDATE_SAFE_AREA_INSETS, insets, false);
    this.updateWishlistStatus = (data) => this._embedInstance.playerApiCall(PLAYER_EVENTS.PROVIDE_WISHLIST_STATUS, data, false);
    this.close = () => this._embedInstance.close({ origin: 'api' });
    this.getEventInfoState = () => this._embedInstance.playerApiCall(PLAYER_EVENTS.EVENT_INFO_STATE, null, true);
  }
}
